import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import { Helmet } from 'react-helmet-async'

import appConfig from '~/src/App/config'

/**
 * Renders its children into the document's head
 *
 * @component
 * @alias Head
 */
const HeadComponent = ({ children = null }) => {
  const { config } = useConnect('selectConfig')
  const appName = config.APP || appConfig.APP

  return (
    <Helmet titleTemplate={`%s | ${appName}`} defaultTitle={appName}>
      {children}
    </Helmet>
  )
}
HeadComponent.displayName = 'Head'
HeadComponent.propTypes = {
  children: PropTypes.node,
}

export default HeadComponent
